import uniq from "lodash-es/uniq";
import { Reducer } from "redux";

import {
    PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_DELETE_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_DELETE_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_DELETE_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_LOAD_API_FAILURE,
    PRODUCT_DETAIL_LOAD_API_REQUEST,
    PRODUCT_DETAIL_LOAD_API_SUCCESS,
    PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_FAILURE,
    PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_REQUEST,
    PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_SUCCESS,
    PRODUCT_DETAIL_MARK_OK_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_MARK_OK_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_MARK_OK_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_NEW_MESSAGE_API_SUCCESS,
    PRODUCT_DETAIL_NEW_REPLY_API_SUCCESS,
    PRODUCT_DETAIL_NEW_REVIEW_API_SUCCESS,
    PRODUCT_DETAIL_REMOVE_BUYER_API_REQUEST,
    PRODUCT_DETAIL_REPOST_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_REPOST_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_REPOST_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_RESTORE_BUYER_API_REQUEST,
    PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_FAILURE,
    PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_REQUEST,
    PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_SUCCESS,
    PRODUCT_DETAIL_UNDELETE_PRODUCT_API_FAILURE,
    PRODUCT_DETAIL_UNDELETE_PRODUCT_API_REQUEST,
    PRODUCT_DETAIL_UNDELETE_PRODUCT_API_SUCCESS,
    PRODUCT_DETAIL_VIEW_API_SUCCESS,
    ProductDetailActivateProductApiFailureAction,
    ProductDetailActivateProductApiRequestAction,
    ProductDetailActivateProductApiSuccessAction,
    ProductDetailDeactivateProductApiFailureAction,
    ProductDetailDeactivateProductApiRequestAction,
    ProductDetailDeactivateProductApiSuccessAction,
    ProductDetailDeleteProductApiFailureAction,
    ProductDetailDeleteProductApiRequestAction,
    ProductDetailDeleteProductApiSuccessAction,
    ProductDetailLoadApiFailureAction,
    ProductDetailLoadApiRequestAction,
    ProductDetailLoadApiSuccessAction,
    ProductDetailLoadRelatedProductsApiFailureAction,
    ProductDetailLoadRelatedProductsApiRequestAction,
    ProductDetailLoadRelatedProductsApiSuccessAction,
    ProductDetailMarkOKProductApiFailureAction,
    ProductDetailMarkOKProductApiRequestAction,
    ProductDetailMarkOKProductApiSuccessAction,
    ProductDetailNewMessageApiSuccessAction,
    ProductDetailNewReplyApiSuccessAction,
    ProductDetailNewReviewApiSuccessAction,
    ProductDetailRemoveBuyerApiRequestAction,
    ProductDetailRepostProductApiFailureAction,
    ProductDetailRepostProductApiRequestAction,
    ProductDetailRepostProductApiSuccessAction,
    ProductDetailRestoreBuyerApiRequestAction,
    ProductDetailSetShowSellerPhoneApiFailureAction,
    ProductDetailSetShowSellerPhoneApiRequestAction,
    ProductDetailSetShowSellerPhoneApiSuccessAction,
    ProductDetailUndeleteProductApiFailureAction,
    ProductDetailUndeleteProductApiRequestAction,
    ProductDetailUndeleteProductApiSuccessAction,
    ProductDetailViewApiSuccessAction,
} from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.actions";
import { ComplaintSaveSuccessAction } from "@/mk2/containers/Complaint/Complaint.actions";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";
import processing from "@/mk2/reducers/processing";

type ProductDetailLoadActions =
    | ProductDetailLoadApiRequestAction
    | ProductDetailLoadApiSuccessAction
    | ProductDetailLoadApiFailureAction;

type ProductDetailActivateProductActions =
    | ProductDetailActivateProductApiRequestAction
    | ProductDetailActivateProductApiSuccessAction
    | ProductDetailActivateProductApiFailureAction;

type ProductDetailDeactivateProductActions =
    | ProductDetailDeactivateProductApiRequestAction
    | ProductDetailDeactivateProductApiSuccessAction
    | ProductDetailDeactivateProductApiFailureAction;

type ProductDetailRepostProductActions =
    | ProductDetailRepostProductApiRequestAction
    | ProductDetailRepostProductApiSuccessAction
    | ProductDetailRepostProductApiFailureAction;

type ProductDetailDeleteProductActions =
    | ProductDetailDeleteProductApiRequestAction
    | ProductDetailDeleteProductApiSuccessAction
    | ProductDetailDeleteProductApiFailureAction;

type ProductDetailUndeleteProductActions =
    | ProductDetailUndeleteProductApiRequestAction
    | ProductDetailUndeleteProductApiSuccessAction
    | ProductDetailUndeleteProductApiFailureAction;

type ProductDetailMarkOKProductActions =
    | ProductDetailMarkOKProductApiRequestAction
    | ProductDetailMarkOKProductApiSuccessAction
    | ProductDetailMarkOKProductApiFailureAction;

type ProductDetailSetShowSellerPhoneActions =
    | ProductDetailSetShowSellerPhoneApiRequestAction
    | ProductDetailSetShowSellerPhoneApiSuccessAction
    | ProductDetailSetShowSellerPhoneApiFailureAction;

type ProductDetailLoadRelatedProductsActions =
    | ProductDetailLoadRelatedProductsApiRequestAction
    | ProductDetailLoadRelatedProductsApiSuccessAction
    | ProductDetailLoadRelatedProductsApiFailureAction;

export interface PerProductState {
    productId: number;
    messagesIds: number[];
    reviewsIds: number[];
    buyersIds: number[];
    relatedProductsIds: number[];
    closedBuyersIds: number[];
    loadingState: LoadingState;
    errorMessage: string;
    lastNoteId: number;
    sellerPhone: string;
    loadedAt: number;
    setShowSellerPhoneErrorMessage: string;
    relatedProductsLoadingState: LoadingState;
    relatedProductsHasNext: boolean;
    strollerId: number;
    strollerReviewedBySeller: boolean;
    viewsCount: number;
    historyCount: number;
}

export const perProductInitialState: PerProductState = {
    productId: null,
    messagesIds: [],
    reviewsIds: [],
    buyersIds: [],
    relatedProductsIds: [],
    closedBuyersIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
    lastNoteId: null,
    sellerPhone: null,
    loadedAt: null,
    setShowSellerPhoneErrorMessage: null,
    relatedProductsLoadingState: LoadingState.INIT,
    relatedProductsHasNext: true,
    strollerId: null,
    strollerReviewedBySeller: false,
    viewsCount: 0,
    historyCount: 0,
};

type PerProductActions =
    | ProductDetailLoadActions
    | ComplaintSaveSuccessAction
    | ProductDetailNewMessageApiSuccessAction
    | ProductDetailNewReviewApiSuccessAction
    | ProductDetailNewReplyApiSuccessAction
    | ProductDetailRemoveBuyerApiRequestAction
    | ProductDetailSetShowSellerPhoneActions
    | ProductDetailLoadRelatedProductsActions
    | ProductDetailRestoreBuyerApiRequestAction
    | ProductDetailViewApiSuccessAction;

const perProductReducer: Reducer<PerProductState> = (
    state: PerProductState = perProductInitialState,
    action: PerProductActions,
) => {
    switch (action.type) {
        case PRODUCT_DETAIL_LOAD_API_REQUEST:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        case PRODUCT_DETAIL_LOAD_API_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                relatedProductsIds: action.response.result.relatedProducts,
            };
        case PRODUCT_DETAIL_LOAD_API_SUCCESS:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                productId: action.response.result.product,
                messagesIds: action.response.result.messages,
                buyersIds: action.response.result.buyers,
                reviewsIds: action.response.result.reviews,
                closedBuyersIds: action.response.result.closedBuyers,
                relatedProductsIds: action.response.result.relatedProducts,
                lastNoteId: action.response.result.lastNote,
                sellerPhone: action.sellerPhone,
                loadedAt: Date.now(),
                strollerId: action.response.result.stroller,
                strollerReviewedBySeller: action.response.result.strollerReviewedBySeller,
                viewsCount: action.viewsCount,
                historyCount: action.historyCount,
            };
        case PRODUCT_DETAIL_NEW_MESSAGE_API_SUCCESS:
            return {
                ...state,
                buyersIds: [action.response.result.buyer, ...state.buyersIds],
                messagesIds: [...state.messagesIds, action.response.result.message],
            };
        case PRODUCT_DETAIL_NEW_REPLY_API_SUCCESS:
            return {
                ...state,
                messagesIds: [...state.messagesIds, action.response.result.message],
            };
        case PRODUCT_DETAIL_NEW_REVIEW_API_SUCCESS:
            return {
                ...state,
                reviewsIds: [...state.reviewsIds, action.response.result.review],
            };
        case PRODUCT_DETAIL_REMOVE_BUYER_API_REQUEST:
            return {
                ...state,
                closedBuyersIds: [...state.closedBuyersIds, action.buyerId],
                buyersIds: state.buyersIds.filter((b) => b !== action.buyerId),
            };
        case PRODUCT_DETAIL_RESTORE_BUYER_API_REQUEST:
            return {
                ...state,
                buyersIds: [...state.buyersIds, action.buyerId],
                closedBuyersIds: state.closedBuyersIds.filter((b) => b !== action.buyerId),
            };
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_SUCCESS:
            return {
                ...state,
                sellerPhone: action.sellerPhone,
            };
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_REQUEST:
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_FAILURE:
            return {
                ...state,
                setShowSellerPhoneErrorMessage: errorMessage(
                    state.setShowSellerPhoneErrorMessage,
                    action,
                ),
            };
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_REQUEST:
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_FAILURE:
            return {
                ...state,
                relatedProductsLoadingState: loadingState(
                    state.relatedProductsLoadingState,
                    action,
                ),
            };
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_SUCCESS:
            return {
                ...state,
                relatedProductsLoadingState: loadingState(
                    state.relatedProductsLoadingState,
                    action,
                ),
                relatedProductsIds: uniq<number>([
                    ...state.relatedProductsIds,
                    ...action.response.result.relatedProducts,
                ]),
                relatedProductsHasNext: action.hasNext,
            };
        case PRODUCT_DETAIL_VIEW_API_SUCCESS:
            return {
                ...state,
                viewsCount: action.viewsCount,
            };

        default:
            return state;
    }
};

export interface State {
    slugs: {
        [slug: string]: PerProductState;
    };
    activatingProductIds: number[];
    deactivatingProductIds: number[];
    deletingProductIds: number[];
    undeletingProductIds: number[];
    repostingProductIds: number[];
    markingOKProductIds: number[];
}

export const initialState: State = {
    slugs: {},
    activatingProductIds: [],
    deactivatingProductIds: [],
    deletingProductIds: [],
    undeletingProductIds: [],
    repostingProductIds: [],
    markingOKProductIds: [],
};

type ProductDetailActions =
    | ProductDetailLoadActions
    | ProductDetailActivateProductActions
    | ProductDetailDeactivateProductActions
    | ProductDetailDeleteProductActions
    | ProductDetailUndeleteProductActions
    | ProductDetailRepostProductActions
    | ProductDetailMarkOKProductActions
    | ProductDetailLoadRelatedProductsActions
    | ProductDetailNewMessageApiSuccessAction
    | ProductDetailNewReviewApiSuccessAction
    | ProductDetailNewReplyApiSuccessAction
    | ProductDetailRemoveBuyerApiRequestAction
    | ProductDetailSetShowSellerPhoneActions
    | ProductDetailRestoreBuyerApiRequestAction
    | ProductDetailViewApiSuccessAction;

const reducer: Reducer<State> = (state: State = initialState, action: ProductDetailActions) => {
    switch (action.type) {
        case PRODUCT_DETAIL_LOAD_API_REQUEST:
        case PRODUCT_DETAIL_LOAD_API_FAILURE:
        case PRODUCT_DETAIL_LOAD_API_SUCCESS:
        case PRODUCT_DETAIL_NEW_MESSAGE_API_SUCCESS:
        case PRODUCT_DETAIL_NEW_REVIEW_API_SUCCESS:
        case PRODUCT_DETAIL_NEW_REPLY_API_SUCCESS:
        case PRODUCT_DETAIL_REMOVE_BUYER_API_REQUEST:
        case PRODUCT_DETAIL_RESTORE_BUYER_API_REQUEST:
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_SUCCESS:
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_REQUEST:
        case PRODUCT_DETAIL_SET_SHOW_SELLER_PHONE_API_FAILURE:
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_SUCCESS:
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_REQUEST:
        case PRODUCT_DETAIL_LOAD_RELATED_PRODUCTS_API_FAILURE:
            return {
                ...state,
                slugs: {
                    ...state.slugs,
                    [action.slug]: perProductReducer(state.slugs[action.slug], action),
                },
            };
        case PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_ACTIVATE_PRODUCT_API_FAILURE:
            return {
                ...state,
                activatingProductIds: processing<ProductDetailActivateProductActions>(
                    "PRODUCT_DETAIL_ACTIVATE_PRODUCT_API",
                    (act) => act.productId,
                )(state.activatingProductIds, action),
            };
        case PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API_FAILURE:
            return {
                ...state,
                deactivatingProductIds: processing<ProductDetailDeactivateProductActions>(
                    "PRODUCT_DETAIL_DEACTIVATE_PRODUCT_API",
                    (act) => act.productId,
                )(state.deactivatingProductIds, action),
            };
        case PRODUCT_DETAIL_DELETE_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_DELETE_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_DELETE_PRODUCT_API_FAILURE:
            return {
                ...state,
                deletingProductIds: processing<ProductDetailDeleteProductActions>(
                    "PRODUCT_DETAIL_DELETE_PRODUCT_API",
                    (act) => act.productId,
                )(state.deletingProductIds, action),
            };
        case PRODUCT_DETAIL_UNDELETE_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_UNDELETE_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_UNDELETE_PRODUCT_API_FAILURE:
            return {
                ...state,
                undeletingProductIds: processing<ProductDetailUndeleteProductActions>(
                    "PRODUCT_DETAIL_UNDELETE_PRODUCT_API",
                    (act) => act.productId,
                )(state.undeletingProductIds, action),
            };
        case PRODUCT_DETAIL_REPOST_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_REPOST_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_REPOST_PRODUCT_API_FAILURE:
            return {
                ...state,
                repostingProductIds: processing<ProductDetailRepostProductActions>(
                    "PRODUCT_DETAIL_REPOST_PRODUCT_API",
                    (act) => act.productId,
                )(state.repostingProductIds, action),
            };
        case PRODUCT_DETAIL_MARK_OK_PRODUCT_API_REQUEST:
        case PRODUCT_DETAIL_MARK_OK_PRODUCT_API_SUCCESS:
        case PRODUCT_DETAIL_MARK_OK_PRODUCT_API_FAILURE:
            return {
                ...state,
                markingOKProductIds: processing<ProductDetailMarkOKProductActions>(
                    "PRODUCT_DETAIL_MARK_OK_PRODUCT_API",
                    (act) => act.productId,
                )(state.markingOKProductIds, action),
            };
        case PRODUCT_DETAIL_VIEW_API_SUCCESS:
            return {
                ...state,
                slugs: {
                    ...state.slugs,
                    [action.productSlug]: perProductReducer(
                        state.slugs[action.productSlug],
                        action,
                    ),
                },
            };

        default:
            return state;
    }
};

export default reducer;
